// @flow
import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

// Material
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';

// Assets
import error404 from './404.svg';

// Data
import { routes } from '../data/routes';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(3),
    position: 'relative',
    textAlign: 'center',
  },
  pageImage: {
    height: '180px',
    margin: theme.spacing(2),
    maxWidth: '100%',
  },
  list: {
    listStyleType: 'none',
  },
}));

const NoMatch = () => {
  const classes = useStyles();

  return (
    <Container>
      <Helmet title="Page not found - Naexguide" />
      <Paper className={classes.root}>
        <img src={error404} alt="404 error" className={classes.pageImage} />
        <h1>Oops!</h1>
        <h2>We couldn't find the page you are looking for.</h2>
        <p>Error code: 404</p>
        <p>Here are some other helpful links:</p>
        <ul className={classes.list}>
          {routes.map((route, i) => (
            <li>
              <Link to={route.path} key={i}>
                {route.title}
              </Link>
            </li>
          ))}
        </ul>
      </Paper>
    </Container>
  );
};

export default NoMatch;
